import type { Team } from '@/api/v4/team.api';

import { useNavigateTo } from '@/routes/hooks/use-navigate-to';

import { projectFormState } from './project.state';
import { useSetAtom } from 'jotai';

export const useNavigateToProjectFormWithCompanyData = () => {
  const setProjectForm = useSetAtom(projectFormState);
  const navigateTo = useNavigateTo();

  const navigateToProjectFormWithCompanyData = (
    organization: Team['organization'] | null,
  ) => {
    setProjectForm(currentForm => ({
      ...currentForm,
      organization,
    }));

    navigateTo.createProject();
  };

  return {
    navigateToProjectFormWithCompanyData,
  };
};
